module.exports = __webpack_public_path__ + "img/illu-tray.196a51aa.svg";